import React from 'react';
import { PageLayout } from '../components/PageLayout';
import { companyInfo } from '../mockData';

export const Privacy = () => {
  return (
    <PageLayout>
      {/* Hero Section */}
      <section className="relative -mt-20 lg:pt-40 pt-28  pb-16 md:pb-20 bg-[#262d37] text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-3xl">
            <h1 className="text-2xl md:text-3xl font-bold mb-1">
              Política de Privacidade
            </h1>
            <p className="text-base md:text-lg text-neutral-300">
              Última atualização: {new Date().toLocaleDateString('pt-PT')}
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-10 lg:py-20 bg-[#f2f1ec]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="prose prose-neutral max-w-none space-y-12 text-neutral-800">

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">1. Introdução</h2>
              <p className="text-base leading-relaxed">
                A <strong>{companyInfo.legalName}</strong> (proprietária da marca <strong>{companyInfo.name}</strong>) respeita a sua privacidade e está comprometida em proteger os seus dados pessoais. Esta política de privacidade explica como recolhemos, utilizamos, armazenamos e protegemos as suas informações pessoais quando visita o nosso site.
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">2. Dados que Recolhemos</h2>
              <p className="text-base leading-relaxed">
                Podemos recolher e processar os seguintes tipos de dados pessoais:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-base">
                <li><strong>Dados de identificação:</strong> nome, endereço de e-mail, número de telefone;</li>
                <li><strong>Dados técnicos:</strong> endereço IP, tipo de navegador, sistema operativo, páginas visitadas, tempo de permanência no site;</li>
                <li><strong>Dados de comunicação:</strong> informações que nos fornece através do formulário de contacto ou e-mail.</li>
              </ul>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">3. Como Utilizamos os Seus Dados</h2>
              <p className="text-base leading-relaxed">
                Utilizamos os seus dados pessoais para:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-base">
                <li>Responder às suas solicitações e fornecer informações sobre os nossos serviços;</li>
                <li>Melhorar o funcionamento e a experiência do utilizador no nosso site;</li>
                <li>Cumprir obrigações legais e regulamentares;</li>
                <li>Enviar comunicações de marketing (apenas com o seu consentimento explícito).</li>
              </ul>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">4. Base Legal para o Processamento</h2>
              <p className="text-base leading-relaxed">
                Processamos os seus dados pessoais com base em:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-base">
                <li><strong>Consentimento:</strong> quando nos dá permissão explícita para processar os seus dados;</li>
                <li><strong>Execução de contrato:</strong> quando necessário para responder às suas solicitações;</li>
                <li><strong>Interesse legítimo:</strong> para melhorar os nossos serviços e o desempenho do site;</li>
                <li><strong>Obrigações legais:</strong> quando necessário para cumprir disposições legais.</li>
              </ul>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">5. Partilha de Dados</h2>
              <p className="text-base leading-relaxed">
                Não vendemos, alugamos ou partilhamos os seus dados pessoais com terceiros, exceto:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-base">
                <li>Quando necessário para operar o nosso site ou prestar serviços (ex.: fornecedores de alojamento web);</li>
                <li>Quando exigido por lei ou autoridades competentes;</li>
                <li>Com o seu consentimento explícito.</li>
              </ul>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">6. Retenção de Dados</h2>
              <p className="text-base leading-relaxed">
                Mantemos os seus dados pessoais apenas pelo tempo necessário para cumprir os fins para os quais foram recolhidos, incluindo requisitos legais ou contabilísticos. Quando já não forem necessários, serão eliminados de forma segura.
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">7. Os Seus Direitos</h2>
              <p className="text-base leading-relaxed">
                De acordo com o RGPD, tem os seguintes direitos:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-base">
                <li><strong>Direito de acesso:</strong> solicitar uma cópia dos dados pessoais que possuímos;</li>
                <li><strong>Direito de retificação:</strong> corrigir dados inexatos ou incompletos;</li>
                <li><strong>Direito ao apagamento:</strong> solicitar a eliminação dos seus dados;</li>
                <li><strong>Direito à limitação do processamento;</strong></li>
                <li><strong>Direito à portabilidade dos dados;</strong></li>
                <li><strong>Direito de oposição ao processamento;</strong></li>
                <li><strong>Direito de retirar o consentimento a qualquer momento.</strong></li>
              </ul>
              <p className="text-base leading-relaxed">
                Para exercer estes direitos, contacte-nos através de: <a href={`mailto:${companyInfo.email}`} className="text-black font-semibold hover:underline">{companyInfo.email}</a>.
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">8. Cookies</h2>
              <p className="text-base leading-relaxed">
                O nosso site pode utilizar cookies para melhorar a experiência do utilizador. Pode configurar o seu navegador para recusar cookies, mas algumas funcionalidades poderão ficar limitadas.
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">9. Segurança</h2>
              <p className="text-base leading-relaxed">
                Implementamos medidas técnicas e organizativas adequadas para proteger os seus dados pessoais contra acesso não autorizado, alteração ou destruição. No entanto, nenhum método de transmissão pela Internet ou armazenamento eletrónico é totalmente seguro.
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">10. Alterações a Esta Política</h2>
              <p className="text-base leading-relaxed">
                Podemos atualizar esta política de privacidade periodicamente. A versão mais recente estará sempre disponível nesta página, com indicação da data da última atualização.
              </p>
            </div>

            <div className="space-y-2 pt-8 border-t border-neutral-400">
              <h2 className="text-2xl md:text-3xl font-bold text-black">Contactos</h2>
              <p className="text-base leading-relaxed">
                Para questões sobre esta política de privacidade, contacte-nos:
              </p>
              <div className="bg-white/30 p-8 rounded-lg space-y-3">
                <p className="text-lg font-bold text-black">{companyInfo.legalName} ({companyInfo.name})</p>
                <div className="space-y-2">
                  <p className="text-base">
                    <strong>E-mail:</strong> <br />
                    <a href={`mailto:${companyInfo.email}`} className="hover:underline">{companyInfo.email}</a><br />
                    <a href={`mailto:${companyInfo.projectsEmail}`} className="hover:underline">{companyInfo.projectsEmail}</a>
                  </p>
                  <p className="text-base">
                    <strong>Telefone:</strong> <br />
                    <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="hover:underline">
                      {companyInfo.phone}
                    </a>
                  </p>
                  <p className="text-base">
                    <strong>Localização:</strong> <br />
                    {companyInfo.address}
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </PageLayout>
  );
};
